import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { NotificationProvider } from "./contexts/NotificationContext";
import HomePage from "./pages/HomePage";
import IdeasPage from "./pages/IdeasPage";
import WatchlistPage from "./pages/WatchlistPage";
import ProfilePage from "./pages/ProfilePage";
import AdminPanel from "./pages/AdminPanel";
import DashboardPage from "./pages/DashboardPage";
import ScoresPage from "./pages/ScoresPage";
import TradingHistoryPage from "./pages/TradingHistoryPage";
import InvitationsPage from "./pages/InvitationsPage";
import LeaderboardPage from "./pages/LeaderboardPage";
import SubscriptionSuccess from "./pages/SubscriptionSuccess";
import SubscriptionCancel from "./pages/SubscriptionCancel";
import AuthCallback from "./components/AuthCallback";
import BillingPage from "./pages/BillingPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import EulaPage from "./pages/EulaPage";
import RefundPolicyPage from "./pages/RefundPolicyPage";
import ContactUsPage from "./pages/ContactUsPage";
import AdminRefundsPage from "./pages/AdminRefundsPage";
import AboutPage from "./pages/AboutPage";
import PressPage from "./pages/PressPage";
import AdminPressPage from "./pages/AdminPressPage";
import AdminResolutionAuditPage from "./pages/AdminResolutionAuditPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import HowItWorksPage from "./pages/HowItWorksPage";
import AppDownloadPage from "./pages/AppDownloadPage";
import LearnHubPage from "./pages/LearnHubPage";
import LearnArticlePage from "./pages/LearnArticlePage";
import MarketCategoryPage from "./pages/MarketCategoryPage";
import MarketDetailPage from "./pages/MarketDetailPage";
import ChangelogPage from "./pages/ChangelogPage";

// Router component that checks for session_id in URL fragment
function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment (not query params) for session_id - must be synchronous
  // This prevents race conditions by processing new session_id FIRST
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/category/:category" element={<HomePage />} />
      <Route path="/live" element={<HomePage />} />
      <Route path="/scores" element={<ScoresPage />} />
      <Route path="/ideas" element={<IdeasPage />} />
      <Route path="/watchlist" element={<WatchlistPage />} />
      <Route path="/profile" element={<ProfilePage />} />
      <Route path="/profile/billing" element={<BillingPage />} />
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="/trading" element={<TradingHistoryPage />} />
      <Route path="/invitations" element={<InvitationsPage />} />
      <Route path="/leaderboard" element={<LeaderboardPage />} />
      <Route path="/admin" element={<AdminPanel />} />
      <Route path="/admin/refunds" element={<AdminRefundsPage />} />
      <Route path="/admin/press" element={<AdminPressPage />} />
      <Route path="/admin/resolution-audit" element={<AdminResolutionAuditPage />} />
      <Route path="/privacy" element={<PrivacyPolicyPage />} />
      <Route path="/terms" element={<Navigate to="/eula" replace />} />
      <Route path="/eula" element={<EulaPage />} />
      <Route path="/refund-policy" element={<RefundPolicyPage />} />
      <Route path="/contact" element={<ContactUsPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/how-it-works" element={<HowItWorksPage />} />
      <Route path="/learn" element={<LearnHubPage />} />
      <Route path="/learn/:slug" element={<LearnArticlePage />} />
      <Route path="/markets" element={<MarketCategoryPage isHub />} />
      <Route path="/markets/:category" element={<MarketCategoryPage />} />
      <Route path="/markets/:category/:slug" element={<MarketDetailPage />} />
      <Route path="/app" element={<AppDownloadPage route="/app" />} />
      <Route path="/ios" element={<AppDownloadPage route="/ios" />} />
      <Route path="/android" element={<AppDownloadPage route="/android" />} />
      <Route path="/changelog" element={<ChangelogPage />} />
      <Route path="/press" element={<PressPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/api" element={<HomePage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/subscription/success" element={<SubscriptionSuccess />} />
      <Route path="/subscription/cancel" element={<SubscriptionCancel />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App dark">
      <BrowserRouter>
        <AuthProvider>
          <NotificationProvider>
            <AppRouter />
          </NotificationProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
